import type { AuditEvent } from 'src/api/facade/types'

import { mutateMockDb } from '../db/state'
import { createId } from '../utils/ids'

export const appendAuditEvent = (
  payload: Omit<AuditEvent, 'id' | 'createdAt'>
): AuditEvent => {
  let created: AuditEvent = {
    id: '',
    createdAt: '',
    ...payload
  }

  mutateMockDb((db) => {
    created = {
      id: createId('audit'),
      createdAt: new Date().toISOString(),
      ...payload
    }
    db.audit.unshift(created)
  })

  return created
}
